import { createTheme, ThemeProvider as MUThemeProvider } from "@mui/material";
import React, { useCallback, useMemo, useState } from "react";
import { ThemeProvider } from "styled-components";
import themes from "./themes";

interface ThemeToggleContextProps {
    toggle: () => void;
}

const ThemeToggleContext = React.createContext<ThemeToggleContextProps>({
    toggle: () => {}
});

export const useTheme = (): ThemeToggleContextProps => React.useContext(ThemeToggleContext);

const MUTheme = createTheme({
    typography: { button: { textTransform: "none" } },
    palette: { primary: { main: "#1e88e5" } }
});

export function PrimThemeProvider({ children }: { children: React.ReactNode }): React.ReactElement {
    const [themeState, setThemeState] = useState({
        mode: "light"
    });

    const toggle = useCallback((): void => {
        const mode = themeState.mode === "light" ? "dark" : "light";
        setThemeState({ mode });
    }, [themeState]);

    const value = useMemo(
        () => ({
            toggle
        }),
        [toggle]
    );

    return (
        <ThemeToggleContext.Provider value={value}>
            <MUThemeProvider theme={MUTheme}>
                <ThemeProvider theme={themeState.mode === "light" ? themes.lightTheme : themes.darkTheme}>
                    {children}
                </ThemeProvider>
            </MUThemeProvider>
        </ThemeToggleContext.Provider>
    );
}
